<ng-container *ngIf="isDesktop; then desktopTemplate; else mobileTemplate"> </ng-container>

<ng-template #desktopTemplate>
	<obg-m-dialog-layout [loading]="isBusy" #dialog [navbarOptions]="navbarOptions">
		<ng-container *ngTemplateOutlet="renewPasswordForm"></ng-container>
	</obg-m-dialog-layout>
</ng-template>

<ng-template #mobileTemplate>
	<obg-m-dialog-layout [loading]="isBusy" #dialog navbar="true" [navbarOptions]="navbarOptions">
		<ng-container *ngTemplateOutlet="renewPasswordForm"></ng-container>
	</obg-m-dialog-layout>
</ng-template>

<!-- Templates -->
<ng-template #renewPasswordForm>
	<form class="obg-m-renew-password-wrapper" novalidate (ngSubmit)="submit()" [formGroup]="formGroup">
		<h2
			class="obg-m-renew-password-title"
			[innerHtml]="'login.renew-password.title' | translate"
			role="heading"
		></h2>

		<p class="obg-m-renew-password-info" [innerHtml]="'login.renew-password.info' | translate"></p>

		<div class="obg-m-renew-password-content">
			<mat-form-field class="obg-m-renew-password-username">
				<input
					matInput
					type="email"
					formControlName="username"
					test-id="renew-password-username"
					data-test-id="renew-password-username"
					[placeholder]="'login.renew-password.email.placeholder' | translate"
				/>
			</mat-form-field>
			<obg-common-validation-renderer
				[input]="formGroup.controls.username"
				[disabled]="formGroup.disabled"
				translationPrefix="forgot-password.email"
			>
			</obg-common-validation-renderer>
			<div *ngIf="isAamsJurisdiction$ | async">
				<mat-form-field class="obg-m-renew-password-recovery-question">
					<mat-select
						formControlName="recoveryQuestion"
						test-id="renew-password-recovery-question"
						data-test-id="renew-password-recovery-question"
						[placeholder]="'login.renew-password.recovery-question.placeholder' | translate"
					>
						<mat-option
							*ngFor="let recoveryQuestion of recoveryQuestions$ | async"
							[value]="recoveryQuestion.value"
						>
							{{ recoveryQuestion.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<obg-common-validation-renderer
					[input]="formGroup.controls.recoveryQuestion"
					[disabled]="formGroup.disabled"
					translationPrefix="forgot-password.recovery-question"
				>
				</obg-common-validation-renderer>
				<mat-form-field class="obg-m-renew-password-recovery-answer">
					<input
						matInput
						type="text"
						formControlName="recoveryAnswer"
						test-id="renew-password-recovery-answer"
						data-test-id="renew-password-recovery-answer"
						[placeholder]="'login.renew-password.recovery-answer.placeholder' | translate"
					/>
				</mat-form-field>
				<obg-common-validation-renderer
					[input]="formGroup.controls.recoveryAnswer"
					[disabled]="formGroup.disabled"
					translationPrefix="forgot-password.recovery-answer"
				>
				</obg-common-validation-renderer>
			</div>
		</div>

		<div class="obg-m-renew-password-actions">
			<span *ngIf="isFormSubmitted && hasSucceeded$ | async" class="email-sent-warning">
				{{ "login.renew-password.email-sent" | translate }}
			</span>
			<button
				mat-flat-button
				class="renew-password-submit-btn"
				color="accent"
				type="submit"
				test-id="renew-password-submit"
				data-test-id="renew-password-submit"
				[disabled]="(hasSucceeded$ | async) || formGroup.invalid"
			>
				{{ "login.renew-password.reset-password" | translate }}
			</button>
			<a *ngIf="isFormSubmitted && hasSucceeded$ | async" class="email-resent-link" (click)="submit()"
				>{{ "login.renew-password.email-resent" | translate}}
			</a>
		</div>

		<p *ngIf="!isDesktop && !(hasSucceeded$ | async)" class="obg-m-renew-password-note">
			{{ "login.renew-password.note.contact-support" | translate }}
		</p>

		<span
			*ngIf="isFormSubmitted && (hasFailed$ | async) && (hasSucceeded$ | async) !== true"
			class="obg-m-renew-password-error"
		>
			{{ "forgot-password.e_forgottenpasswords" | translate }}
		</span>
	</form>
</ng-template>
